import type { IconDefinition } from '../../types'

export default {
  details: [20, 20, [], '', 'M3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V3C20 1.34315 18.6569 0 17 0H3ZM4.25 9.17969H15.75C15.8881 9.17969 16 9.29937 16 9.4375V10.5C16 10.6381 15.8881 10.75 15.75 10.75H4.25C4.11188 10.75 4 10.6381 4 10.5V9.4375C4 9.29937 4.11188 9.17969 4.25 9.17969Z'],
  name: 'uiCheckboxIndeterminate',
  oldName: 'cuiCheckboxIndeterminate'
} as IconDefinition
